export default {
    methods: {
        autoDownloadFile() {
            if (this.downloadUrl) {
                try {
                    let link = document.createElement('a'),
                        filename = this.downloadUrl.substring(this.downloadUrl.lastIndexOf('/') + 1);

                    link.href = this.downloadUrl;
                    link.target = '_blank';
                    link.download = filename;
                    document.body.appendChild(link);
                    link.click();
                    this.$nextTick(() => {
                        this.markAsDownloaded();
                        link.remove();
                    })
                } catch (error) {
                    console.error('error auto download')
                }
            }
        },
    }
}
